class ApiResolver {
  registeredDomains = {
    "api.scantrust.com": import.meta.env.VITE_API_BACKEND_PROD,
    "st4.ch": import.meta.env.VITE_API_BACKEND_PROD,
    "api.staging.scantrust.io": import.meta.env.VITE_API_BACKEND_STAGING,
    "qr1.ch": import.meta.env.VITE_API_BACKEND_STAGING
  };

  constructor() {}

  register(domain, apiDomain) {
    if (apiDomain === undefined) {
      apiDomain = domain;
    }
    this.registeredDomains[domain] = apiDomain;
  }

  getApiDomain(domain) {
    return this.registeredDomains[domain];
  }
}

const globalApiResolver = new ApiResolver();

export { globalApiResolver as default, ApiResolver };
